export const TOKEN_REFRESH_RETRY_DELAYS_MS: readonly number[] = [500, 2000]

const SESSION_REJECTED_STATUSES = new Set([401, 403])

const isSessionRejected = (error: unknown): boolean => {
	const status = (error as { response?: { status?: number } }).response?.status
	return status !== undefined && SESSION_REJECTED_STATUSES.has(status)
}

const waitFor = (durationMs: number): Promise<void> =>
	new Promise(resolve => {
		setTimeout(resolve, durationMs)
	})

export const retryUnlessSessionRejected = async <T>(
	call: () => Promise<T>,
	retryDelaysMs: readonly number[]
): Promise<T> => {
	try {
		return await call()
	} catch (error) {
		const [retryDelay, ...remainingDelaysMs] = retryDelaysMs
		if (retryDelay === undefined || isSessionRejected(error)) {
			throw error
		}
		await waitFor(retryDelay)
		return retryUnlessSessionRejected(call, remainingDelaysMs)
	}
}
